import { render, staticRenderFns } from "./DownloadStatement.vue?vue&type=template&id=34e42705&scoped=true&"
import script from "./DownloadStatement.vue?vue&type=script&lang=js&"
export * from "./DownloadStatement.vue?vue&type=script&lang=js&"
import style0 from "./DownloadStatement.vue?vue&type=style&index=0&id=34e42705&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e42705",
  null
  
)

export default component.exports